var c = Object.defineProperty;
var v = (t, l, n) => l in t ? c(t, l, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[l] = n;
var h = (t, l, n) => (v(t, typeof l != "symbol" ? l + "" : l, n), n);
class Ce {
  constructor(l, n) {
    h(this, "http");
    h(this, "baseUrl");
    h(this, "jsonParseReviver");
    this.http = n || window, this.baseUrl = l ?? "";
  }
  /**
   * @return Success
   */
  getAssignment(l, n) {
    let a = this.baseUrl + "/v1/{companyId}/assignment/{id}";
    if (l == null)
      throw new Error("The parameter 'companyId' must be defined.");
    if (a = a.replace("{companyId}", encodeURIComponent("" + l)), n == null)
      throw new Error("The parameter 'id' must be defined.");
    a = a.replace("{id}", encodeURIComponent("" + n)), a = a.replace(/[?&]$/, "");
    let e = {
      method: "GET",
      headers: {
        Accept: "text/plain"
      }
    };
    return this.http.fetch(a, e).then((r) => this.processGetAssignment(r));
  }
  processGetAssignment(l) {
    const n = l.status;
    let a = {};
    return l.headers && l.headers.forEach && l.headers.forEach((e, r) => a[r] = e), n === 200 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), r;
    }) : n === 400 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Bad Request", n, e, a, r);
    }) : n === 401 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Unauthorized", n, e, a, r);
    }) : n === 404 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Not Found", n, e, a, r);
    }) : n !== 200 && n !== 204 ? l.text().then((e) => u("An unexpected server error occurred.", n, e, a)) : Promise.resolve(null);
  }
  /**
   * @param body (optional) 
   * @return Success
   */
  searchAssignmentRelations(l, n, a) {
    let e = this.baseUrl + "/v1/{companyId}/assignment/{id}/relations";
    if (l == null)
      throw new Error("The parameter 'companyId' must be defined.");
    if (e = e.replace("{companyId}", encodeURIComponent("" + l)), n == null)
      throw new Error("The parameter 'id' must be defined.");
    e = e.replace("{id}", encodeURIComponent("" + n)), e = e.replace(/[?&]$/, "");
    let i = {
      body: JSON.stringify(a),
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain"
      }
    };
    return this.http.fetch(e, i).then((o) => this.processSearchAssignmentRelations(o));
  }
  processSearchAssignmentRelations(l) {
    const n = l.status;
    let a = {};
    return l.headers && l.headers.forEach && l.headers.forEach((e, r) => a[r] = e), n === 200 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), r;
    }) : n === 400 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Bad Request", n, e, a, r);
    }) : n === 401 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Unauthorized", n, e, a, r);
    }) : n === 404 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Not Found", n, e, a, r);
    }) : n !== 200 && n !== 204 ? l.text().then((e) => u("An unexpected server error occurred.", n, e, a)) : Promise.resolve(null);
  }
  /**
   * @return Success
   */
  getAssignmentPreview(l, n) {
    let a = this.baseUrl + "/v1/{companyId}/assignment/{id}/preview";
    if (l == null)
      throw new Error("The parameter 'companyId' must be defined.");
    if (a = a.replace("{companyId}", encodeURIComponent("" + l)), n == null)
      throw new Error("The parameter 'id' must be defined.");
    a = a.replace("{id}", encodeURIComponent("" + n)), a = a.replace(/[?&]$/, "");
    let e = {
      method: "GET",
      headers: {
        Accept: "text/plain"
      }
    };
    return this.http.fetch(a, e).then((r) => this.processGetAssignmentPreview(r));
  }
  processGetAssignmentPreview(l) {
    const n = l.status;
    let a = {};
    return l.headers && l.headers.forEach && l.headers.forEach((e, r) => a[r] = e), n === 200 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), r;
    }) : n === 400 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Bad Request", n, e, a, r);
    }) : n === 401 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Unauthorized", n, e, a, r);
    }) : n === 404 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Not Found", n, e, a, r);
    }) : n !== 200 && n !== 204 ? l.text().then((e) => u("An unexpected server error occurred.", n, e, a)) : Promise.resolve(null);
  }
  /**
   * @param body (optional) 
   * @return Success
   */
  getAssignmentRelationOverview(l) {
    let n = this.baseUrl + "/v1/assignmentRelation/search";
    n = n.replace(/[?&]$/, "");
    let e = {
      body: JSON.stringify(l),
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain"
      }
    };
    return this.http.fetch(n, e).then((r) => this.processGetAssignmentRelationOverview(r));
  }
  processGetAssignmentRelationOverview(l) {
    const n = l.status;
    let a = {};
    return l.headers && l.headers.forEach && l.headers.forEach((e, r) => a[r] = e), n === 200 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), r;
    }) : n === 400 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Bad Request", n, e, a, r);
    }) : n === 401 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Unauthorized", n, e, a, r);
    }) : n === 404 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Not Found", n, e, a, r);
    }) : n !== 200 && n !== 204 ? l.text().then((e) => u("An unexpected server error occurred.", n, e, a)) : Promise.resolve(null);
  }
  /**
   * @return Success
   */
  getChecklist(l, n, a) {
    let e = this.baseUrl + "/v1/{companyId}/assignment/{assignmentId}/checklist/{id}";
    if (l == null)
      throw new Error("The parameter 'companyId' must be defined.");
    if (e = e.replace("{companyId}", encodeURIComponent("" + l)), n == null)
      throw new Error("The parameter 'assignmentId' must be defined.");
    if (e = e.replace("{assignmentId}", encodeURIComponent("" + n)), a == null)
      throw new Error("The parameter 'id' must be defined.");
    e = e.replace("{id}", encodeURIComponent("" + a)), e = e.replace(/[?&]$/, "");
    let r = {
      method: "GET",
      headers: {
        Accept: "text/plain"
      }
    };
    return this.http.fetch(e, r).then((i) => this.processGetChecklist(i));
  }
  processGetChecklist(l) {
    const n = l.status;
    let a = {};
    return l.headers && l.headers.forEach && l.headers.forEach((e, r) => a[r] = e), n === 200 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), r;
    }) : n === 400 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Bad Request", n, e, a, r);
    }) : n === 401 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Unauthorized", n, e, a, r);
    }) : n === 404 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Not Found", n, e, a, r);
    }) : n !== 200 && n !== 204 ? l.text().then((e) => u("An unexpected server error occurred.", n, e, a)) : Promise.resolve(null);
  }
  /**
   * @param body (optional) 
   * @return Success
   */
  searchChecklist(l, n, a) {
    let e = this.baseUrl + "/v1/{companyId}/assignment/{assignmentId}/checklist/search";
    if (l == null)
      throw new Error("The parameter 'companyId' must be defined.");
    if (e = e.replace("{companyId}", encodeURIComponent("" + l)), n == null)
      throw new Error("The parameter 'assignmentId' must be defined.");
    e = e.replace("{assignmentId}", encodeURIComponent("" + n)), e = e.replace(/[?&]$/, "");
    let i = {
      body: JSON.stringify(a),
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain"
      }
    };
    return this.http.fetch(e, i).then((o) => this.processSearchChecklist(o));
  }
  processSearchChecklist(l) {
    const n = l.status;
    let a = {};
    return l.headers && l.headers.forEach && l.headers.forEach((e, r) => a[r] = e), n === 200 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), r;
    }) : n === 400 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Bad Request", n, e, a, r);
    }) : n === 401 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Unauthorized", n, e, a, r);
    }) : n === 404 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Not Found", n, e, a, r);
    }) : n !== 200 && n !== 204 ? l.text().then((e) => u("An unexpected server error occurred.", n, e, a)) : Promise.resolve(null);
  }
  /**
   * @param culture (optional) 
   * @return Success
   */
  getChecklistItem(l, n, a, e) {
    let r = this.baseUrl + "/v1/{companyId}/assignment/{assignmentId}/checklistItem/{id}?";
    if (l == null)
      throw new Error("The parameter 'companyId' must be defined.");
    if (r = r.replace("{companyId}", encodeURIComponent("" + l)), n == null)
      throw new Error("The parameter 'id' must be defined.");
    if (r = r.replace("{id}", encodeURIComponent("" + n)), e == null)
      throw new Error("The parameter 'assignmentId' must be defined.");
    if (r = r.replace("{assignmentId}", encodeURIComponent("" + e)), a === null)
      throw new Error("The parameter 'culture' cannot be null.");
    a !== void 0 && (r += "culture=" + encodeURIComponent("" + a) + "&"), r = r.replace(/[?&]$/, "");
    let i = {
      method: "GET",
      headers: {
        Accept: "text/plain"
      }
    };
    return this.http.fetch(r, i).then((o) => this.processGetChecklistItem(o));
  }
  processGetChecklistItem(l) {
    const n = l.status;
    let a = {};
    return l.headers && l.headers.forEach && l.headers.forEach((e, r) => a[r] = e), n === 200 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), r;
    }) : n === 400 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Bad Request", n, e, a, r);
    }) : n === 401 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Unauthorized", n, e, a, r);
    }) : n === 404 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Not Found", n, e, a, r);
    }) : n !== 200 && n !== 204 ? l.text().then((e) => u("An unexpected server error occurred.", n, e, a)) : Promise.resolve(null);
  }
  /**
   * @param body (optional) 
   * @return Success
   */
  searchChecklistItem(l, n, a) {
    let e = this.baseUrl + "/v1/{companyId}/assignment/{assignmentId}/checklistItem/search";
    if (l == null)
      throw new Error("The parameter 'companyId' must be defined.");
    if (e = e.replace("{companyId}", encodeURIComponent("" + l)), n == null)
      throw new Error("The parameter 'assignmentId' must be defined.");
    e = e.replace("{assignmentId}", encodeURIComponent("" + n)), e = e.replace(/[?&]$/, "");
    let i = {
      body: JSON.stringify(a),
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain"
      }
    };
    return this.http.fetch(e, i).then((o) => this.processSearchChecklistItem(o));
  }
  processSearchChecklistItem(l) {
    const n = l.status;
    let a = {};
    return l.headers && l.headers.forEach && l.headers.forEach((e, r) => a[r] = e), n === 200 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), r;
    }) : n === 400 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Bad Request", n, e, a, r);
    }) : n === 401 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Unauthorized", n, e, a, r);
    }) : n === 404 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Not Found", n, e, a, r);
    }) : n !== 200 && n !== 204 ? l.text().then((e) => u("An unexpected server error occurred.", n, e, a)) : Promise.resolve(null);
  }
  /**
   * @return Success
   * @deprecated
   */
  requestChecklistItemToReview(l, n, a) {
    let e = this.baseUrl + "/v1/{companyId}/assignment/{assignmentId}/checklistItem/{id}/review";
    if (l == null)
      throw new Error("The parameter 'companyId' must be defined.");
    if (e = e.replace("{companyId}", encodeURIComponent("" + l)), n == null)
      throw new Error("The parameter 'id' must be defined.");
    if (e = e.replace("{id}", encodeURIComponent("" + n)), a == null)
      throw new Error("The parameter 'assignmentId' must be defined.");
    e = e.replace("{assignmentId}", encodeURIComponent("" + a)), e = e.replace(/[?&]$/, "");
    let r = {
      method: "PUT",
      headers: {
        Accept: "text/plain"
      }
    };
    return this.http.fetch(e, r).then((i) => this.processRequestChecklistItemToReview(i));
  }
  processRequestChecklistItemToReview(l) {
    const n = l.status;
    let a = {};
    return l.headers && l.headers.forEach && l.headers.forEach((e, r) => a[r] = e), n === 200 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), r;
    }) : n === 400 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Bad Request", n, e, a, r);
    }) : n === 401 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Unauthorized", n, e, a, r);
    }) : n === 404 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Not Found", n, e, a, r);
    }) : n !== 200 && n !== 204 ? l.text().then((e) => u("An unexpected server error occurred.", n, e, a)) : Promise.resolve(null);
  }
  /**
   * @return Success
   */
  requestChecklistItemReview(l, n, a) {
    let e = this.baseUrl + "/v1/{companyId}/assignment/{assignmentId}/checklistItem/{id}/status/review";
    if (l == null)
      throw new Error("The parameter 'companyId' must be defined.");
    if (e = e.replace("{companyId}", encodeURIComponent("" + l)), n == null)
      throw new Error("The parameter 'id' must be defined.");
    if (e = e.replace("{id}", encodeURIComponent("" + n)), a == null)
      throw new Error("The parameter 'assignmentId' must be defined.");
    e = e.replace("{assignmentId}", encodeURIComponent("" + a)), e = e.replace(/[?&]$/, "");
    let r = {
      method: "PUT",
      headers: {
        Accept: "text/plain"
      }
    };
    return this.http.fetch(e, r).then((i) => this.processRequestChecklistItemReview(i));
  }
  processRequestChecklistItemReview(l) {
    const n = l.status;
    let a = {};
    return l.headers && l.headers.forEach && l.headers.forEach((e, r) => a[r] = e), n === 200 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), r;
    }) : n === 400 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Bad Request", n, e, a, r);
    }) : n === 401 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Unauthorized", n, e, a, r);
    }) : n === 404 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Not Found", n, e, a, r);
    }) : n !== 200 && n !== 204 ? l.text().then((e) => u("An unexpected server error occurred.", n, e, a)) : Promise.resolve(null);
  }
  /**
   * @param body (optional) 
   * @return Success
   */
  searchDocument(l, n, a) {
    let e = this.baseUrl + "/v1/{companyId}/assignment/{assignmentId}/document/search";
    if (l == null)
      throw new Error("The parameter 'companyId' must be defined.");
    if (e = e.replace("{companyId}", encodeURIComponent("" + l)), n == null)
      throw new Error("The parameter 'assignmentId' must be defined.");
    e = e.replace("{assignmentId}", encodeURIComponent("" + n)), e = e.replace(/[?&]$/, "");
    let i = {
      body: JSON.stringify(a),
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain"
      }
    };
    return this.http.fetch(e, i).then((o) => this.processSearchDocument(o));
  }
  processSearchDocument(l) {
    const n = l.status;
    let a = {};
    return l.headers && l.headers.forEach && l.headers.forEach((e, r) => a[r] = e), n === 200 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), r;
    }) : n === 400 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Bad Request", n, e, a, r);
    }) : n === 401 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Unauthorized", n, e, a, r);
    }) : n === 404 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Not Found", n, e, a, r);
    }) : n !== 200 && n !== 204 ? l.text().then((e) => u("An unexpected server error occurred.", n, e, a)) : Promise.resolve(null);
  }
  /**
   * @param uploadOnBehalfOfAssignmentRelationId (optional) 
   * @param fileDetails (optional) 
   * @return Success
   */
  uploadBlob(l, n, a, e, r) {
    let i = this.baseUrl + "/v1/{companyId}/assignment/{assignmentId}/document/{checklistItemId}/upload";
    if (l == null)
      throw new Error("The parameter 'companyId' must be defined.");
    if (i = i.replace("{companyId}", encodeURIComponent("" + l)), n == null)
      throw new Error("The parameter 'assignmentId' must be defined.");
    if (i = i.replace("{assignmentId}", encodeURIComponent("" + n)), a == null)
      throw new Error("The parameter 'checklistItemId' must be defined.");
    i = i.replace("{checklistItemId}", encodeURIComponent("" + a)), i = i.replace(/[?&]$/, "");
    const o = new FormData();
    if (e == null)
      throw new Error("The parameter 'uploadOnBehalfOfAssignmentRelationId' cannot be null.");
    if (o.append("UploadOnBehalfOfAssignmentRelationId", e.toString()), r == null)
      throw new Error("The parameter 'fileDetails' cannot be null.");
    o.append("FileDetails", r.data, r.fileName ? r.fileName : "FileDetails");
    let d = {
      body: o,
      method: "POST",
      headers: {
        Accept: "text/plain"
      }
    };
    return this.http.fetch(i, d).then((s) => this.processUploadBlob(s));
  }
  processUploadBlob(l) {
    const n = l.status;
    let a = {};
    return l.headers && l.headers.forEach && l.headers.forEach((e, r) => a[r] = e), n === 200 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), r;
    }) : n === 400 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Bad Request", n, e, a, r);
    }) : n === 401 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Unauthorized", n, e, a, r);
    }) : n === 404 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Not Found", n, e, a, r);
    }) : n === 415 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Client Error", n, e, a, r);
    }) : n !== 200 && n !== 204 ? l.text().then((e) => u("An unexpected server error occurred.", n, e, a)) : Promise.resolve(null);
  }
  /**
   * @param ipAddress (optional) 
   * @return Success
   */
  generateDownloadUrl(l, n, a, e) {
    let r = this.baseUrl + "/v1/{companyId}/assignment/{assignmentId}/document/{documentId}/downloadUrl?";
    if (l == null)
      throw new Error("The parameter 'companyId' must be defined.");
    if (r = r.replace("{companyId}", encodeURIComponent("" + l)), n == null)
      throw new Error("The parameter 'assignmentId' must be defined.");
    if (r = r.replace("{assignmentId}", encodeURIComponent("" + n)), a == null)
      throw new Error("The parameter 'documentId' must be defined.");
    if (r = r.replace("{documentId}", encodeURIComponent("" + a)), e === null)
      throw new Error("The parameter 'ipAddress' cannot be null.");
    e !== void 0 && (r += "ipAddress=" + encodeURIComponent("" + e) + "&"), r = r.replace(/[?&]$/, "");
    let i = {
      method: "GET",
      headers: {
        Accept: "text/plain"
      }
    };
    return this.http.fetch(r, i).then((o) => this.processGenerateDownloadUrl(o));
  }
  processGenerateDownloadUrl(l) {
    const n = l.status;
    let a = {};
    return l.headers && l.headers.forEach && l.headers.forEach((e, r) => a[r] = e), n === 200 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), r;
    }) : n === 400 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Bad Request", n, e, a, r);
    }) : n === 401 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Unauthorized", n, e, a, r);
    }) : n === 404 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Not Found", n, e, a, r);
    }) : n !== 200 && n !== 204 ? l.text().then((e) => u("An unexpected server error occurred.", n, e, a)) : Promise.resolve(null);
  }
  /**
   * @return Success
   */
  generateInitialDocumentDownloadUrl(l, n, a) {
    let e = this.baseUrl + "/v1/{companyId}/assignment/{assignmentId}/document/{documentId}/downloadInitialDocumentUrl";
    if (l == null)
      throw new Error("The parameter 'companyId' must be defined.");
    if (e = e.replace("{companyId}", encodeURIComponent("" + l)), n == null)
      throw new Error("The parameter 'assignmentId' must be defined.");
    if (e = e.replace("{assignmentId}", encodeURIComponent("" + n)), a == null)
      throw new Error("The parameter 'documentId' must be defined.");
    e = e.replace("{documentId}", encodeURIComponent("" + a)), e = e.replace(/[?&]$/, "");
    let r = {
      method: "GET",
      headers: {
        Accept: "text/plain"
      }
    };
    return this.http.fetch(e, r).then((i) => this.processGenerateInitialDocumentDownloadUrl(i));
  }
  processGenerateInitialDocumentDownloadUrl(l) {
    const n = l.status;
    let a = {};
    return l.headers && l.headers.forEach && l.headers.forEach((e, r) => a[r] = e), n === 200 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), r;
    }) : n === 400 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Bad Request", n, e, a, r);
    }) : n === 401 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Unauthorized", n, e, a, r);
    }) : n === 404 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Not Found", n, e, a, r);
    }) : n !== 200 && n !== 204 ? l.text().then((e) => u("An unexpected server error occurred.", n, e, a)) : Promise.resolve(null);
  }
  /**
   * @param body (optional) 
   * @return Success
   */
  searchEmployee(l, n) {
    let a = this.baseUrl + "/v1/{companyId}/employee/search";
    if (l == null)
      throw new Error("The parameter 'companyId' must be defined.");
    a = a.replace("{companyId}", encodeURIComponent("" + l)), a = a.replace(/[?&]$/, "");
    let r = {
      body: JSON.stringify(n),
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain"
      }
    };
    return this.http.fetch(a, r).then((i) => this.processSearchEmployee(i));
  }
  processSearchEmployee(l) {
    const n = l.status;
    let a = {};
    return l.headers && l.headers.forEach && l.headers.forEach((e, r) => a[r] = e), n === 200 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), r;
    }) : n === 400 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Bad Request", n, e, a, r);
    }) : n === 401 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Unauthorized", n, e, a, r);
    }) : n === 404 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Not Found", n, e, a, r);
    }) : n !== 200 && n !== 204 ? l.text().then((e) => u("An unexpected server error occurred.", n, e, a)) : Promise.resolve(null);
  }
  /**
   * @return Success
   * @deprecated
   */
  entityNotification(l) {
    let n = this.baseUrl + "/v1/{realEstateAgencyId}/eventHub/authenticate";
    if (l == null)
      throw new Error("The parameter 'realEstateAgencyId' must be defined.");
    n = n.replace("{realEstateAgencyId}", encodeURIComponent("" + l)), n = n.replace(/[?&]$/, "");
    let a = {
      method: "POST",
      headers: {
        Accept: "text/plain"
      }
    };
    return this.http.fetch(n, a).then((e) => this.processEntityNotification(e));
  }
  processEntityNotification(l) {
    const n = l.status;
    let a = {};
    return l.headers && l.headers.forEach && l.headers.forEach((e, r) => a[r] = e), n === 200 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), r;
    }) : n === 201 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Created", n, e, a, r);
    }) : n === 302 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Redirect", n, e, a, r);
    }) : n === 401 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Unauthorized", n, e, a, r);
    }) : n === 404 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Not Found", n, e, a, r);
    }) : n !== 200 && n !== 204 ? l.text().then((e) => u("An unexpected server error occurred.", n, e, a)) : Promise.resolve(null);
  }
  /**
   * @return Success
   */
  getForm(l, n, a) {
    let e = this.baseUrl + "/v1/{companyId}/form/{id}?";
    if (l == null)
      throw new Error("The parameter 'companyId' must be defined.");
    if (e = e.replace("{companyId}", encodeURIComponent("" + l)), n == null)
      throw new Error("The parameter 'id' must be defined.");
    if (e = e.replace("{id}", encodeURIComponent("" + n)), a == null)
      throw new Error("The parameter 'culture' must be defined and cannot be null.");
    e += "culture=" + encodeURIComponent("" + a) + "&", e = e.replace(/[?&]$/, "");
    let r = {
      method: "GET",
      headers: {
        Accept: "text/plain"
      }
    };
    return this.http.fetch(e, r).then((i) => this.processGetForm(i));
  }
  processGetForm(l) {
    const n = l.status;
    let a = {};
    return l.headers && l.headers.forEach && l.headers.forEach((e, r) => a[r] = e), n === 200 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), r;
    }) : n === 401 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Unauthorized", n, e, a, r);
    }) : n === 404 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Not Found", n, e, a, r);
    }) : n !== 200 && n !== 204 ? l.text().then((e) => u("An unexpected server error occurred.", n, e, a)) : Promise.resolve(null);
  }
  /**
   * @return Success
   */
  getFormSupportedCultures(l, n) {
    let a = this.baseUrl + "/v1/{companyId}/form/{id}/supportedCultures";
    if (l == null)
      throw new Error("The parameter 'companyId' must be defined.");
    if (a = a.replace("{companyId}", encodeURIComponent("" + l)), n == null)
      throw new Error("The parameter 'id' must be defined.");
    a = a.replace("{id}", encodeURIComponent("" + n)), a = a.replace(/[?&]$/, "");
    let e = {
      method: "GET",
      headers: {
        Accept: "text/plain"
      }
    };
    return this.http.fetch(a, e).then((r) => this.processGetFormSupportedCultures(r));
  }
  processGetFormSupportedCultures(l) {
    const n = l.status;
    let a = {};
    return l.headers && l.headers.forEach && l.headers.forEach((e, r) => a[r] = e), n === 200 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), r;
    }) : n === 401 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Unauthorized", n, e, a, r);
    }) : n === 404 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Not Found", n, e, a, r);
    }) : n !== 200 && n !== 204 ? l.text().then((e) => u("An unexpected server error occurred.", n, e, a)) : Promise.resolve(null);
  }
  /**
   * @param culture (optional) 
   * @return Success
   */
  getFormResult(l, n, a) {
    let e = this.baseUrl + "/v1/{companyId}/form/{id}/result?";
    if (l == null)
      throw new Error("The parameter 'companyId' must be defined.");
    if (e = e.replace("{companyId}", encodeURIComponent("" + l)), n == null)
      throw new Error("The parameter 'id' must be defined.");
    if (e = e.replace("{id}", encodeURIComponent("" + n)), a === null)
      throw new Error("The parameter 'culture' cannot be null.");
    a !== void 0 && (e += "culture=" + encodeURIComponent("" + a) + "&"), e = e.replace(/[?&]$/, "");
    let r = {
      method: "GET",
      headers: {
        Accept: "text/plain"
      }
    };
    return this.http.fetch(e, r).then((i) => this.processGetFormResult(i));
  }
  processGetFormResult(l) {
    const n = l.status;
    let a = {};
    return l.headers && l.headers.forEach && l.headers.forEach((e, r) => a[r] = e), n === 200 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), r;
    }) : n === 401 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Unauthorized", n, e, a, r);
    }) : n === 404 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Not Found", n, e, a, r);
    }) : n !== 200 && n !== 204 ? l.text().then((e) => u("An unexpected server error occurred.", n, e, a)) : Promise.resolve(null);
  }
  /**
   * @return Success
   */
  getFormElement(l, n, a, e) {
    let r = this.baseUrl + "/v1/{companyId}/form/{id}/elements/{elementId}?";
    if (l == null)
      throw new Error("The parameter 'companyId' must be defined.");
    if (r = r.replace("{companyId}", encodeURIComponent("" + l)), n == null)
      throw new Error("The parameter 'id' must be defined.");
    if (r = r.replace("{id}", encodeURIComponent("" + n)), a == null)
      throw new Error("The parameter 'elementId' must be defined.");
    if (r = r.replace("{elementId}", encodeURIComponent("" + a)), e == null)
      throw new Error("The parameter 'culture' must be defined and cannot be null.");
    r += "culture=" + encodeURIComponent("" + e) + "&", r = r.replace(/[?&]$/, "");
    let i = {
      method: "GET",
      headers: {
        Accept: "text/plain"
      }
    };
    return this.http.fetch(r, i).then((o) => this.processGetFormElement(o));
  }
  processGetFormElement(l) {
    const n = l.status;
    let a = {};
    return l.headers && l.headers.forEach && l.headers.forEach((e, r) => a[r] = e), n === 200 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), r;
    }) : n === 401 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Unauthorized", n, e, a, r);
    }) : n === 404 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Not Found", n, e, a, r);
    }) : n !== 200 && n !== 204 ? l.text().then((e) => u("An unexpected server error occurred.", n, e, a)) : Promise.resolve(null);
  }
  /**
   * @param body (optional) 
   * @return Success
   */
  searchFormElements(l, n, a) {
    let e = this.baseUrl + "/v1/{companyId}/form/{id}/elements/search";
    if (l == null)
      throw new Error("The parameter 'companyId' must be defined.");
    if (e = e.replace("{companyId}", encodeURIComponent("" + l)), n == null)
      throw new Error("The parameter 'id' must be defined.");
    e = e.replace("{id}", encodeURIComponent("" + n)), e = e.replace(/[?&]$/, "");
    let i = {
      body: JSON.stringify(a),
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain"
      }
    };
    return this.http.fetch(e, i).then((o) => this.processSearchFormElements(o));
  }
  processSearchFormElements(l) {
    const n = l.status;
    let a = {};
    return l.headers && l.headers.forEach && l.headers.forEach((e, r) => a[r] = e), n === 200 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), r;
    }) : n === 400 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Bad Request", n, e, a, r);
    }) : n === 401 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Unauthorized", n, e, a, r);
    }) : n === 404 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Not Found", n, e, a, r);
    }) : n !== 200 && n !== 204 ? l.text().then((e) => u("An unexpected server error occurred.", n, e, a)) : Promise.resolve(null);
  }
  /**
   * @return Success
   */
  get(l, n, a) {
    let e = this.baseUrl + "/v1/{companyId}/form/{formId}/answer/{id}";
    if (l == null)
      throw new Error("The parameter 'companyId' must be defined.");
    if (e = e.replace("{companyId}", encodeURIComponent("" + l)), n == null)
      throw new Error("The parameter 'formId' must be defined.");
    if (e = e.replace("{formId}", encodeURIComponent("" + n)), a == null)
      throw new Error("The parameter 'id' must be defined.");
    e = e.replace("{id}", encodeURIComponent("" + a)), e = e.replace(/[?&]$/, "");
    let r = {
      method: "GET",
      headers: {
        Accept: "text/plain"
      }
    };
    return this.http.fetch(e, r).then((i) => this.processGet(i));
  }
  processGet(l) {
    const n = l.status;
    let a = {};
    return l.headers && l.headers.forEach && l.headers.forEach((e, r) => a[r] = e), n === 200 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), r;
    }) : n === 400 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Bad Request", n, e, a, r);
    }) : n === 401 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Unauthorized", n, e, a, r);
    }) : n === 404 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Not Found", n, e, a, r);
    }) : n !== 200 && n !== 204 ? l.text().then((e) => u("An unexpected server error occurred.", n, e, a)) : Promise.resolve(null);
  }
  /**
   * @param body (optional) 
   * @return Success
   */
  searchAnswers(l, n, a) {
    let e = this.baseUrl + "/v1/{companyId}/form/{formId}/answer/search";
    if (l == null)
      throw new Error("The parameter 'companyId' must be defined.");
    if (e = e.replace("{companyId}", encodeURIComponent("" + l)), n == null)
      throw new Error("The parameter 'formId' must be defined.");
    e = e.replace("{formId}", encodeURIComponent("" + n)), e = e.replace(/[?&]$/, "");
    let i = {
      body: JSON.stringify(a),
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain"
      }
    };
    return this.http.fetch(e, i).then((o) => this.processSearchAnswers(o));
  }
  processSearchAnswers(l) {
    const n = l.status;
    let a = {};
    return l.headers && l.headers.forEach && l.headers.forEach((e, r) => a[r] = e), n === 200 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), r;
    }) : n === 400 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Bad Request", n, e, a, r);
    }) : n === 401 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Unauthorized", n, e, a, r);
    }) : n === 404 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Not Found", n, e, a, r);
    }) : n !== 200 && n !== 204 ? l.text().then((e) => u("An unexpected server error occurred.", n, e, a)) : Promise.resolve(null);
  }
  /**
   * @param body (optional) 
   * @return Success
   */
  update(l, n, a) {
    let e = this.baseUrl + "/v1/{companyId}/form/{formId}/answer";
    if (l == null)
      throw new Error("The parameter 'companyId' must be defined.");
    if (e = e.replace("{companyId}", encodeURIComponent("" + l)), n == null)
      throw new Error("The parameter 'formId' must be defined.");
    e = e.replace("{formId}", encodeURIComponent("" + n)), e = e.replace(/[?&]$/, "");
    let i = {
      body: JSON.stringify(a),
      method: "PUT",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain"
      }
    };
    return this.http.fetch(e, i).then((o) => this.processUpdate(o));
  }
  processUpdate(l) {
    const n = l.status;
    let a = {};
    return l.headers && l.headers.forEach && l.headers.forEach((e, r) => a[r] = e), n === 200 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), r;
    }) : n === 400 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Bad Request", n, e, a, r);
    }) : n === 401 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Unauthorized", n, e, a, r);
    }) : n === 404 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Not Found", n, e, a, r);
    }) : n !== 200 && n !== 204 ? l.text().then((e) => u("An unexpected server error occurred.", n, e, a)) : Promise.resolve(null);
  }
  /**
   * @param body (optional) 
   * @return Success
   */
  searchFormCustomQuestions(l, n, a) {
    let e = this.baseUrl + "/v1/{companyId}/form/{formId}/customQuestion/search";
    if (l == null)
      throw new Error("The parameter 'companyId' must be defined.");
    if (e = e.replace("{companyId}", encodeURIComponent("" + l)), n == null)
      throw new Error("The parameter 'formId' must be defined.");
    e = e.replace("{formId}", encodeURIComponent("" + n)), e = e.replace(/[?&]$/, "");
    let i = {
      body: JSON.stringify(a),
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain"
      }
    };
    return this.http.fetch(e, i).then((o) => this.processSearchFormCustomQuestions(o));
  }
  processSearchFormCustomQuestions(l) {
    const n = l.status;
    let a = {};
    return l.headers && l.headers.forEach && l.headers.forEach((e, r) => a[r] = e), n === 200 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), r;
    }) : n === 400 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Bad Request", n, e, a, r);
    }) : n === 401 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Unauthorized", n, e, a, r);
    }) : n === 404 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Not Found", n, e, a, r);
    }) : n !== 200 && n !== 204 ? l.text().then((e) => u("An unexpected server error occurred.", n, e, a)) : Promise.resolve(null);
  }
  /**
   * @return Success
   */
  getFormCustomQuestion(l, n, a) {
    let e = this.baseUrl + "/v1/{companyId}/form/{formId}/customQuestion/{id}";
    if (l == null)
      throw new Error("The parameter 'companyId' must be defined.");
    if (e = e.replace("{companyId}", encodeURIComponent("" + l)), n == null)
      throw new Error("The parameter 'formId' must be defined.");
    if (e = e.replace("{formId}", encodeURIComponent("" + n)), a == null)
      throw new Error("The parameter 'id' must be defined.");
    e = e.replace("{id}", encodeURIComponent("" + a)), e = e.replace(/[?&]$/, "");
    let r = {
      method: "GET",
      headers: {
        Accept: "text/plain"
      }
    };
    return this.http.fetch(e, r).then((i) => this.processGetFormCustomQuestion(i));
  }
  processGetFormCustomQuestion(l) {
    const n = l.status;
    let a = {};
    return l.headers && l.headers.forEach && l.headers.forEach((e, r) => a[r] = e), n === 200 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), r;
    }) : n === 401 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Unauthorized", n, e, a, r);
    }) : n === 404 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Not Found", n, e, a, r);
    }) : n !== 200 && n !== 204 ? l.text().then((e) => u("An unexpected server error occurred.", n, e, a)) : Promise.resolve(null);
  }
  /**
   * @param body (optional) 
   * @return Success
   */
  updateFormCustomQuestion(l, n, a, e) {
    let r = this.baseUrl + "/v1/{companyId}/form/{formId}/customQuestion/{id}";
    if (l == null)
      throw new Error("The parameter 'companyId' must be defined.");
    if (r = r.replace("{companyId}", encodeURIComponent("" + l)), n == null)
      throw new Error("The parameter 'formId' must be defined.");
    if (r = r.replace("{formId}", encodeURIComponent("" + n)), a == null)
      throw new Error("The parameter 'id' must be defined.");
    r = r.replace("{id}", encodeURIComponent("" + a)), r = r.replace(/[?&]$/, "");
    let o = {
      body: JSON.stringify(e),
      method: "PUT",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain"
      }
    };
    return this.http.fetch(r, o).then((d) => this.processUpdateFormCustomQuestion(d));
  }
  processUpdateFormCustomQuestion(l) {
    const n = l.status;
    let a = {};
    return l.headers && l.headers.forEach && l.headers.forEach((e, r) => a[r] = e), n === 200 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), r;
    }) : n === 400 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Bad Request", n, e, a, r);
    }) : n === 401 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Unauthorized", n, e, a, r);
    }) : n === 404 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Not Found", n, e, a, r);
    }) : n !== 200 && n !== 204 ? l.text().then((e) => u("An unexpected server error occurred.", n, e, a)) : Promise.resolve(null);
  }
  /**
   * @return Success
   */
  deleteFormCustomQuestion(l, n, a) {
    let e = this.baseUrl + "/v1/{companyId}/form/{formId}/customQuestion/{id}";
    if (l == null)
      throw new Error("The parameter 'companyId' must be defined.");
    if (e = e.replace("{companyId}", encodeURIComponent("" + l)), n == null)
      throw new Error("The parameter 'formId' must be defined.");
    if (e = e.replace("{formId}", encodeURIComponent("" + n)), a == null)
      throw new Error("The parameter 'id' must be defined.");
    e = e.replace("{id}", encodeURIComponent("" + a)), e = e.replace(/[?&]$/, "");
    let r = {
      method: "DELETE",
      headers: {}
    };
    return this.http.fetch(e, r).then((i) => this.processDeleteFormCustomQuestion(i));
  }
  processDeleteFormCustomQuestion(l) {
    const n = l.status;
    let a = {};
    return l.headers && l.headers.forEach && l.headers.forEach((e, r) => a[r] = e), n === 200 ? l.text().then((e) => {
    }) : n === 401 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Unauthorized", n, e, a, r);
    }) : n === 404 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Not Found", n, e, a, r);
    }) : n !== 200 && n !== 204 ? l.text().then((e) => u("An unexpected server error occurred.", n, e, a)) : Promise.resolve(null);
  }
  /**
   * @param body (optional) 
   * @return Success
   */
  createFormCustomQuestion(l, n, a) {
    let e = this.baseUrl + "/v1/{companyId}/form/{formId}/customQuestion";
    if (l == null)
      throw new Error("The parameter 'companyId' must be defined.");
    if (e = e.replace("{companyId}", encodeURIComponent("" + l)), n == null)
      throw new Error("The parameter 'formId' must be defined.");
    e = e.replace("{formId}", encodeURIComponent("" + n)), e = e.replace(/[?&]$/, "");
    let i = {
      body: JSON.stringify(a),
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain"
      }
    };
    return this.http.fetch(e, i).then((o) => this.processCreateFormCustomQuestion(o));
  }
  processCreateFormCustomQuestion(l) {
    const n = l.status;
    let a = {};
    return l.headers && l.headers.forEach && l.headers.forEach((e, r) => a[r] = e), n === 200 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), r;
    }) : n === 400 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Bad Request", n, e, a, r);
    }) : n === 401 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Unauthorized", n, e, a, r);
    }) : n === 404 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Not Found", n, e, a, r);
    }) : n !== 200 && n !== 204 ? l.text().then((e) => u("An unexpected server error occurred.", n, e, a)) : Promise.resolve(null);
  }
  /**
   * @return Success
   */
  getRelation(l, n) {
    let a = this.baseUrl + "/v1/{companyId}/relation/{id}";
    if (l == null)
      throw new Error("The parameter 'companyId' must be defined.");
    if (a = a.replace("{companyId}", encodeURIComponent("" + l)), n == null)
      throw new Error("The parameter 'id' must be defined.");
    a = a.replace("{id}", encodeURIComponent("" + n)), a = a.replace(/[?&]$/, "");
    let e = {
      method: "GET",
      headers: {
        Accept: "text/plain"
      }
    };
    return this.http.fetch(a, e).then((r) => this.processGetRelation(r));
  }
  processGetRelation(l) {
    const n = l.status;
    let a = {};
    return l.headers && l.headers.forEach && l.headers.forEach((e, r) => a[r] = e), n === 200 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), r;
    }) : n === 400 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Bad Request", n, e, a, r);
    }) : n === 401 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Unauthorized", n, e, a, r);
    }) : n === 404 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Not Found", n, e, a, r);
    }) : n !== 200 && n !== 204 ? l.text().then((e) => u("An unexpected server error occurred.", n, e, a)) : Promise.resolve(null);
  }
  /**
   * @param body (optional) 
   * @return Success
   */
  setRelationDefaultLanguage(l, n, a) {
    let e = this.baseUrl + "/v1/{companyId}/relation/{id}/setDefaultLanguage";
    if (l == null)
      throw new Error("The parameter 'companyId' must be defined.");
    if (e = e.replace("{companyId}", encodeURIComponent("" + l)), n == null)
      throw new Error("The parameter 'id' must be defined.");
    e = e.replace("{id}", encodeURIComponent("" + n)), e = e.replace(/[?&]$/, "");
    let i = {
      body: JSON.stringify(a),
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain"
      }
    };
    return this.http.fetch(e, i).then((o) => this.processSetRelationDefaultLanguage(o));
  }
  processSetRelationDefaultLanguage(l) {
    const n = l.status;
    let a = {};
    return l.headers && l.headers.forEach && l.headers.forEach((e, r) => a[r] = e), n === 200 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), r;
    }) : n === 400 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Bad Request", n, e, a, r);
    }) : n === 401 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Unauthorized", n, e, a, r);
    }) : n === 404 ? l.text().then((e) => {
      let r = null;
      return r = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Not Found", n, e, a, r);
    }) : n !== 200 && n !== 204 ? l.text().then((e) => u("An unexpected server error occurred.", n, e, a)) : Promise.resolve(null);
  }
}
var m = /* @__PURE__ */ ((t) => (t.InConsultation = "InConsultation", t.PerDate = "PerDate", t.Directly = "Directly", t))(m || {}), f = /* @__PURE__ */ ((t) => (t.CentralHeating = "CentralHeating", t.Electricity = "Electricity", t.Water = "Water", t.Attic = "Attic", t.ElectricDoor = "ElectricDoor", t.Loft = "Loft", t))(f || {}), S = /* @__PURE__ */ ((t) => (t.ServiceFlat = "ServiceFlat", t.CommonApartment = "CommonApartment", t.CorridorFlat = "CorridorFlat", t.Beletage = "Beletage", t.Basement = "Basement", t.DoubleUpperHouse = "DoubleUpperHouse", t.NurseryFlat = "NurseryFlat", t.Penthouse = "Penthouse", t.Duplex = "Duplex", t.Triplex = "Triplex", t.Other = "Other", t.Moscow = "Moscow", t.Kavlashvili = "Kavlashvili", t.Lvovi = "Lvovi", t.Khrushovi = "Khrushovi", t.Tukhareli = "Tukhareli", t.Chekhuri = "Chekhuri", t.Kalakuri = "Kalakuri", t.Nonstandard = "Nonstandard", t))(S || {}), p = /* @__PURE__ */ ((t) => (t.Denied = "Denied", t.PendingValidation = "PendingValidation", t.Granted = "Granted", t.NotInvited = "NotInvited", t.Invited = "Invited", t.InviteExpired = "InviteExpired", t.Hidden = "Hidden", t))(p || {}), w = /* @__PURE__ */ ((t) => (t.Vendor = "Vendor", t.Applicant = "Applicant", t.Potential = "Potential", t.Appraiser = "Appraiser", t.Notary = "Notary", t.OtherRelation = "OtherRelation", t.Hidden = "Hidden", t))(w || {}), P = /* @__PURE__ */ ((t) => (t.Bath = "Bath", t.HalfBath = "HalfBath", t.Toilet = "Toilet", t.Shower = "Shower", t.Urinal = "Urinal", t.Bidet = "Bidet", t.SteamCabin = "SteamCabin", t.Jacuzzi = "Jacuzzi", t.DoubleSink = "DoubleSink", t.Sink = "Sink", t.WashbasinFurniture = "WashbasinFurniture", t.WalkInShower = "WalkInShower", t.UnderfloorHeating = "UnderfloorHeating", t.Whirlpool = "Whirlpool", t.WashingMachineConnection = "WashingMachineConnection", t.Sauna = "Sauna", t))(P || {}), N = /* @__PURE__ */ ((t) => (t.ListOfGoods = "ListOfGoods", t.Questionnaire = "Questionnaire", t.PersonalDetails = "PersonalDetails", t))(N || {}), O = /* @__PURE__ */ ((t) => (t.ChecklistItemNotOpen = "ChecklistItemNotOpen", t.InvalidDocumentForChecklist = "InvalidDocumentForChecklist", t.AssignmentRelationNotRegistered = "AssignmentRelationNotRegistered", t.AssignmentRelationNotInvited = "AssignmentRelationNotInvited", t.AssignmentRelationInviteExpired = "AssignmentRelationInviteExpired", t.OnlyPartCanHavePrintSettings = "OnlyPartCanHavePrintSettings", t.OnlySubmitTypeOnlyOneRequiredAllowed = "OnlySubmitTypeOnlyOneRequiredAllowed", t.NoAccessToSpecificBlueprint = "NoAccessToSpecificBlueprint", t.NoAccessToBlueprintType = "NoAccessToBlueprintType", t.BlueprintIncorrectType = "BlueprintIncorrectType", t.InvalidColor = "InvalidColor", t.InvalidDomain = "InvalidDomain", t.SubDomainTaken = "SubDomainTaken", t.SubDomainRequired = "SubDomainRequired", t.DomainRequired = "DomainRequired", t.DuplicateEntity = "DuplicateEntity", t.InvalidOwner = "InvalidOwner", t.InvalidStatus = "InvalidStatus", t.InvalidFileType = "InvalidFileType", t.DocumentAlreadyUploaded = "DocumentAlreadyUploaded", t.IncorrectAnswerType = "IncorrectAnswerType", t.AssignmentRelationAlreadyAccepted = "AssignmentRelationAlreadyAccepted", t.AssignmentRelationAlreadyRequested = "AssignmentRelationAlreadyRequested", t.AssignmentRelationValidationNotRequested = "AssignmentRelationValidationNotRequested", t.CompanyInactive = "CompanyInactive", t.TranslationNotSupported = "TranslationNotSupported", t.DuplicateIndex = "DuplicateIndex", t.ElementHasChildren = "ElementHasChildren", t.ElementDoesNotExist = "ElementDoesNotExist", t.ExpectedActionNotReceived = "ExpectedActionNotReceived", t.InvalidSubmitType = "InvalidSubmitType", t.AlreadyDeleted = "AlreadyDeleted", t.SoftDeleteFirst = "SoftDeleteFirst", t.TargetRequired = "TargetRequired", t.UploadNotReady = "UploadNotReady", t.InvalidSubmitTypeForBlueprint = "InvalidSubmitTypeForBlueprint", t.NameUpdateNotAllowed = "NameUpdateNotAllowed", t.TypeUpdateNotAllowed = "TypeUpdateNotAllowed", t.GeneratedNameUpdateNotAllowed = "GeneratedNameUpdateNotAllowed", t.GeneratedUpdateNotAllowed = "GeneratedUpdateNotAllowed", t.EditOpenFormNotAllowed = "EditOpenFormNotAllowed", t.Required = "Required", t.AnswerTooSmall = "AnswerTooSmall", t.AnswerTooLarge = "AnswerTooLarge", t.CustomQuestionNotAllowed = "CustomQuestionNotAllowed", t.WrongBlueprintProvided = "WrongBlueprintProvided", t.EmailRequired = "EmailRequired", t.InviteTooSoon = "InviteTooSoon", t.AssignmentDoesntSupportPreviews = "AssignmentDoesntSupportPreviews", t.DefaultLanguageMustBeSet = "DefaultLanguageMustBeSet", t.AtLeastOneTranslationMustExists = "AtLeastOneTranslationMustExists", t.InitialDocumentsAreNotAllowed = "InitialDocumentsAreNotAllowed", t.DefaultTranslationRequired = "DefaultTranslationRequired", t.OnlyOneInitialDocumentPerCultureAllowed = "OnlyOneInitialDocumentPerCultureAllowed", t.SubDomainInvalid = "SubDomainInvalid", t.InvalidReviewTarget = "InvalidReviewTarget", t.InvalidExecutor = "InvalidExecutor", t.DocumentTypeChangeNotAllowed = "DocumentTypeChangeNotAllowed", t.MaxNumberOfFiles = "MaxNumberOfFiles", t.NoFilesToUpload = "NoFilesToUpload", t.SubmitTypeNotAllowedForPotentialsAndOtherGroups = "SubmitTypeNotAllowedForPotentialsAndOtherGroups", t.NotAllowedSubmitTypeForPersonalDetails = "NotAllowedSubmitTypeForPersonalDetails", t))(O || {}), R = /* @__PURE__ */ ((t) => (t.Form = "Form", t.IdCard = "IdCard", t.GeneralDocument = "GeneralDocument", t))(R || {}), I = /* @__PURE__ */ ((t) => (t.Open = "Open", t.Review = "Review", t.Closed = "Closed", t.SetupReview = "SetupReview", t))(I || {}), b = /* @__PURE__ */ ((t) => (t.Open = "Open", t.Review = "Review", t.Closed = "Closed", t))(b || {}), A = /* @__PURE__ */ ((t) => (t.Separate = "Separate", t.Specific = "Specific", t.OnlyOneRequired = "OnlyOneRequired", t.None = "None", t.SeparateWithNoAccess = "SeparateWithNoAccess", t))(A || {}), E = /* @__PURE__ */ ((t) => (t.Before1906 = "Before1906", t.Between1906And1930 = "Between1906And1930", t.Between1931And1944 = "Between1931And1944", t.Between1945And1959 = "Between1945And1959", t.Between1960And1970 = "Between1960And1970", t.Between1971And1980 = "Between1971And1980", t.Between1981And1990 = "Between1981And1990", t.Between1991And2000 = "Between1991And2000", t.Between2001And2010 = "Between2001And2010", t.After2010 = "After2010", t))(E || {}), U = /* @__PURE__ */ ((t) => (t.No = "No", t.ComingWith = "ComingWith", t.TakeOverRequired = "TakeOverRequired", t))(U || {}), C = /* @__PURE__ */ ((t) => (t.Nl = "Nl", t.En = "En", t))(C || {}), g = /* @__PURE__ */ ((t) => (t.Portrait = "Portrait", t.Landscape = "Landscape", t))(g || {}), j = /* @__PURE__ */ ((t) => (t.Uploading = "Uploading", t.Uploaded = "Uploaded", t.Refused = "Refused", t.Accepted = "Accepted", t))(j || {}), J = /* @__PURE__ */ ((t) => (t.Group = "Group", t.Individual = "Individual", t))(J || {}), D = /* @__PURE__ */ ((t) => (t.Initial = "Initial", t.Relation = "Relation", t.AppraisalReport = "AppraisalReport", t.ProofOfOwnership = "ProofOfOwnership", t.CadastralMessage = "CadastralMessage", t.CadastralMap = "CadastralMap", t.MeasurementReport = "MeasurementReport", t.ListOfGoods = "ListOfGoods", t.Questionnaire = "Questionnaire", t.PropertyValueDecisionAndAssessments = "PropertyValueDecisionAndAssessments", t.WarrantyCertificatesAndContractDocuments = "WarrantyCertificatesAndContractDocuments", t.ApartmentRightDocuments = "ApartmentRightDocuments", t.Brochure = "Brochure", t.EnergyLabel = "EnergyLabel", t.BuildingPlans = "BuildingPlans", t.StructuralInspectionReport = "StructuralInspectionReport", t.OtherDocuments = "OtherDocuments", t.PersonalDetails = "PersonalDetails", t))(D || {}), G = /* @__PURE__ */ ((t) => (t.Dot = "Dot", t.Letter = "Letter", t.Number = "Number", t))(G || {}), F = /* @__PURE__ */ ((t) => (t.Aplusplus = "Aplusplus", t.Aplus = "Aplus", t.A = "A", t.B = "B", t.C = "C", t.D = "D", t.E = "E", t.F = "F", t.G = "G", t.Aplusplusplus = "Aplusplusplus", t.Aplusplusplusplus = "Aplusplusplusplus", t.Aplusplusplusplusplus = "Aplusplusplusplusplus", t))(F || {}), H = /* @__PURE__ */ ((t) => (t.Gas = "Gas", t.Oil = "Oil", t.Electric = "Electric", t.Pellets = "Pellets", t))(H || {}), W = /* @__PURE__ */ ((t) => (t.Add = "Add", t.Update = "Update", t.Delete = "Delete", t.Error = "Error", t))(W || {}), q = /* @__PURE__ */ ((t) => (t.Join = "Join", t.Leave = "Leave", t))(q || {}), z = /* @__PURE__ */ ((t) => (t.Assignment = "Assignment", t.Relation = "Relation", t.AssignmentRelation = "AssignmentRelation", t.Checklist = "Checklist", t.ChecklistItem = "ChecklistItem", t.Document = "Document", t.BlueprintFilter = "BlueprintFilter", t.CompanyGroup = "CompanyGroup", t.Form = "Form", t.FormAnswer = "FormAnswer", t.FormCustomQuestion = "FormCustomQuestion", t))(z || {}), x = /* @__PURE__ */ ((t) => (t.Other = "Other", t.NotFound = "NotFound", t.BrokenBusinessRule = "BrokenBusinessRule", t.InvalidModelState = "InvalidModelState", t.Forbidden = "Forbidden", t.NullModelState = "NullModelState", t.Unauthorized = "Unauthorized", t))(x || {}), V = /* @__PURE__ */ ((t) => (t.None = "None", t.Owner = "Owner", t.User = "User", t))(V || {}), $ = /* @__PURE__ */ ((t) => (t.LessThan = "LessThan", t.GreaterThan = "GreaterThan", t.LessThanOrEqualTo = "LessThanOrEqualTo", t.GreaterThanOrEqualTo = "GreaterThanOrEqualTo", t.EqualTo = "EqualTo", t.NotEqualTo = "NotEqualTo", t))($ || {}), k = /* @__PURE__ */ ((t) => (t.FixedValueCompare = "FixedValueCompare", t.ElementAnswerCompare = "ElementAnswerCompare", t.ElementOptionCompare = "ElementOptionCompare", t.EmptyValue = "EmptyValue", t))(k || {}), Q = /* @__PURE__ */ ((t) => (t.Show = "Show", t.Hide = "Hide", t.Require = "Require", t))(Q || {}), B = /* @__PURE__ */ ((t) => (t.Public = "Public", t.Private = "Private", t))(B || {}), Y = /* @__PURE__ */ ((t) => (t.Text = "Text", t.Int = "Int", t.Decimal = "Decimal", t.Date = "Date", t.DateTime = "DateTime", t.Radio = "Radio", t.MultiSelect = "MultiSelect", t.Bool = "Bool", t.ListOfItemRadioList = "ListOfItemRadioList", t.TextArea = "TextArea", t.UnknownBool = "UnknownBool", t.KnownBool = "KnownBool", t.InapplicableBool = "InapplicableBool", t.ContractListOfGood = "ContractListOfGood", t))(Y || {}), K = /* @__PURE__ */ ((t) => (t.GeneratedDocument = "GeneratedDocument", t.Form = "Form", t.All = "All", t))(K || {}), X = /* @__PURE__ */ ((t) => (t.Part = "Part", t.Section = "Section", t.Text = "Text", t.Question = "Question", t))(X || {}), Z = /* @__PURE__ */ ((t) => (t.NotInitialized = "NotInitialized", t.Initializing = "Initializing", t.Initialized = "Initialized", t.Exception = "Exception", t))(Z || {}), M = /* @__PURE__ */ ((t) => (t.ListOfGoods = "ListOfGoods", t.Questionnaire = "Questionnaire", t.PersonalDetails = "PersonalDetails", t))(M || {}), L = /* @__PURE__ */ ((t) => (t.AttachedStone = "AttachedStone", t.AttachedWood = "AttachedWood", t.DetachedStone = "DetachedStone", t.DetachedWood = "DetachedWood", t.Indoor = "Indoor", t.GarageBox = "GarageBox", t.UndergroundParking = "UndergroundParking", t.OptionForGarage = "OptionForGarage", t.CarPort = "CarPort", t.ParkingSpace = "ParkingSpace", t.GarageWithCarPort = "GarageWithCarPort", t.Garage = "Garage", t.ParkingFee = "ParkingFee", t.NoParking = "NoParking", t.FreeParking = "FreeParking", t.NoGarage = "NoGarage", t))(L || {}), y = /* @__PURE__ */ ((t) => (t.ToConstruct = "ToConstruct", t.Derelict = "Derelict", t.Normal = "Normal", t.BeautifullyLandscaped = "BeautifullyLandscaped", t.Groomed = "Groomed", t.ConstructedByArchitect = "ConstructedByArchitect", t))(y || {}), _ = /* @__PURE__ */ ((t) => (t.BackGarden = "BackGarden", t.FrontGarden = "FrontGarden", t.SideGarden = "SideGarden", t.SurroundingGarden = "SurroundingGarden", t.PatioAtrium = "PatioAtrium", t.Place = "Place", t.SunTerrace = "SunTerrace", t.EnclosedYard = "EnclosedYard", t))(_ || {}), T = /* @__PURE__ */ ((t) => (t.Boiler = "Boiler", t.CoalStove = "CoalStove", t.BlockHeating = "BlockHeating", t.DistrictHeating = "DistrictHeating", t.Hearth = "Hearth", t.HotAirHeating = "HotAirHeating", t.AirConditioning = "AirConditioning", t.GasStoves = "GasStoves", t.Fireplace = "Fireplace", t.FireplaceOption = "FireplaceOption", t.HeatedFloors = "HeatedFloors", t.PartialHeatedFloors = "PartialHeatedFloors", t.SolarPanels = "SolarPanels", t.NoHeating = "NoHeating", t.ElectricHeating = "ElectricHeating", t.WallHeating = "WallHeating", t.HeatPump = "HeatPump", t.HeatRecoveryInstallation = "HeatRecoveryInstallation", t.GeothermalEnergy = "GeothermalEnergy", t.WoodStove = "WoodStove", t.GasStove = "GasStove", t.FreeStandingHeating = "FreeStandingHeating", t.AutomaticHeating = "AutomaticHeating", t.Stove = "Stove", t.CombinedHeating = "CombinedHeating", t.SolidFuel = "SolidFuel", t.Ion = "Ion", t.WaterHeater = "WaterHeater", t.AllBurner = "AllBurner", t.PelletStove = "PelletStove", t))(T || {}), ee = /* @__PURE__ */ ((t) => (t.Boiler = "Boiler", t.CentralHeating = "CentralHeating", t.WaterHeaterRental = "WaterHeaterRental", t.WaterHeaterOwnership = "WaterHeaterOwnership", t.GasBoilerRental = "GasBoilerRental", t.GasBoilerOwnership = "GasBoilerOwnership", t.ElectricBoilerRental = "ElectricBoilerRental", t.ElectricBoilerOwnership = "ElectricBoilerOwnership", t.SolarWaterHeater = "SolarWaterHeater", t.SolarPanels = "SolarPanels", t.DistrictHeating = "DistrictHeating", t.NoHeating = "NoHeating", t.FlowThroughBoiler = "FlowThroughBoiler", t.GeothermalHeat = "GeothermalHeat", t))(ee || {}), te = /* @__PURE__ */ ((t) => (t.DikeHouse = "DikeHouse", t.SplitLevelHouse = "SplitLevelHouse", t.DriveInHouse = "DriveInHouse", t.SemiBungalow = "SemiBungalow", t.PatioHouse = "PatioHouse", t.PileHouse = "PileHouse", t.CourtyardHouse = "CourtyardHouse", t.BusinessServiceHouse = "BusinessServiceHouse", t.WaterHouse = "WaterHouse", t.WindWaterMill = "WindWaterMill", t.QuadrantHouse = "QuadrantHouse", t))(te || {}), re = /* @__PURE__ */ ((t) => (t.SingleFamilyHouse = "SingleFamilyHouse", t.Mansion = "Mansion", t.Villa = "Villa", t.CountryHouse = "CountryHouse", t.Bungalow = "Bungalow", t.ResidentialFarm = "ResidentialFarm", t.CanalHouse = "CanalHouse", t.HouseBoat = "HouseBoat", t.MobileHome = "MobileHome", t.GipsyCart = "GipsyCart", t))(re || {}), ne = /* @__PURE__ */ ((t) => (t.DetachedHouse = "DetachedHouse", t.LinkedHouse = "LinkedHouse", t.SemiDetachedHouseOneRoof = "SemiDetachedHouseOneRoof", t.RowHouseMiddle = "RowHouseMiddle", t.RowHouseCorner = "RowHouseCorner", t.RowHouseEnd = "RowHouseEnd", t.SemiDetachedHouse = "SemiDetachedHouse", t.SemiDetachedLinkedHouseOneRoof = "SemiDetachedLinkedHouseOneRoof", t.OffsetHouse = "OffsetHouse", t))(ne || {}), le = /* @__PURE__ */ ((t) => (t.Yes = "Yes", t.No = "No", t.Inapplicable = "Inapplicable", t))(le || {}), ae = /* @__PURE__ */ ((t) => (t.RoofInsulation = "RoofInsulation", t.WallInsulation = "WallInsulation", t.FloorInsulation = "FloorInsulation", t.FullyInsulated = "FullyInsulated", t.CavityWall = "CavityWall", t.AnchorlessCavityWall = "AnchorlessCavityWall", t.EcoBuilding = "EcoBuilding", t.DoubleGlazing = "DoubleGlazing", t.PartialDoubleGlazing = "PartialDoubleGlazing", t.Sash = "Sash", t.LargelyDoubleGlazing = "LargelyDoubleGlazing", t.TripleGlazing = "TripleGlazing", t.CrackingSeal = "CrackingSeal", t.HrGlass = "HrGlass", t))(ae || {}), ue = /* @__PURE__ */ ((t) => (t.BuiltInEquipment = "BuiltInEquipment", t.CookingIsland = "CookingIsland", t.RinseIsland = "RinseIsland", t.ElectricStove = "ElectricStove", t.GasStove = "GasStove", t.WoodStove = "WoodStove", t))(ue || {}), ie = /* @__PURE__ */ ((t) => (t.Open = "Open", t.Dining = "Dining", t.Closed = "Closed", t.SemiOpen = "SemiOpen", t.Appliances = "Appliances", t))(ie || {}), oe = /* @__PURE__ */ ((t) => (t.Yes = "Yes", t.No = "No", t))(oe || {}), he = /* @__PURE__ */ ((t) => (t.Undefined = "Undefined", t.StaysBehind = "StaysBehind", t.ComingWith = "ComingWith", t.ForTakeover = "ForTakeover", t.NoAnswer = "NoAnswer", t))(he || {}), de = /* @__PURE__ */ ((t) => (t.House = "House", t.Apartment = "Apartment", t.Parking = "Parking", t.Plot = "Plot", t.SummerCottage = "SummerCottage", t.Other = "Other", t.ProductionHall = "ProductionHall", t.OutdoorArea = "OutdoorArea", t.HotelRestaurantCafe = "HotelRestaurantCafe", t.Office = "Office", t.Lot = "Lot", t.PracticeSpace = "PracticeSpace", t.RetailSpace = "RetailSpace", t.Warehouse = "Warehouse", t.WarehouseProduction = "WarehouseProduction", t.Services = "Services", t.Garage = "Garage", t.ArableCompany = "ArableCompany", t.LooseSoil = "LooseSoil", t.DairyFarmingCompany = "DairyFarmingCompany", t.PoultryCompany = "PoultryCompany", t.HorsesCompany = "HorsesCompany", t.ProductionRights = "ProductionRights", t.Horticultural = "Horticultural", t.PigHolding = "PigHolding", t.VealCalvesFarming = "VealCalvesFarming", t.AgriculturalHouse = "AgriculturalHouse", t.CattleFarming = "CattleFarming", t.BusinessSpace = "BusinessSpace", t.Ammoniac = "Ammoniac", t.AvebeShares = "AvebeShares", t.BeetQuota = "BeetQuota", t.MilkQuota = "MilkQuota", t.PoultryRights = "PoultryRights", t.PaymentEntitlements = "PaymentEntitlements", t.PigRights = "PigRights", t.Leisure = "Leisure", t.Investment = "Investment", t.SocialProperty = "SocialProperty", t))(de || {}), se = /* @__PURE__ */ ((t) => (t.ForestEdge = "ForestEdge", t.Waterside = "Waterside", t.Park = "Park", t.OnBusyStreet = "OnBusyStreet", t.OnQuietStreet = "OnQuietStreet", t.CentralCityCenter = "CentralCityCenter", t.ResidentialArea = "ResidentialArea", t.UnobstructedView = "UnobstructedView", t.ShelteredLocation = "ShelteredLocation", t.OpenArea = "OpenArea", t.OutsideVillage = "OutsideVillage", t.OnWaterway = "OnWaterway", t.ForestedArea = "ForestedArea", t.NearRailwayStation = "NearRailwayStation", t.Suburb = "Suburb", t.BusinessPark = "BusinessPark", t.Other = "Other", t.LRTE = "LRTE", t.HarborArea = "HarborArea", t.IndustrialArea = "IndustrialArea", t.OfficePark = "OfficePark", t.PRTE = "PRTE", t.ShoppingCenter = "ShoppingCenter", t.Countryside = "Countryside", t.NearHighway = "NearHighway", t.NearPublicTransport = "NearPublicTransport", t.NearSchool = "NearSchool", t.Seaside = "Seaside", t.SecludedLocation = "SecludedLocation", t.Standalone = "Standalone", t.SubDivision = "SubDivision", t.FurnitureBoulevard = "FurnitureBoulevard", t.IndoorShopping = "IndoorShopping", t.SeaView = "SeaView", t.LocalCenter = "LocalCenter", t.Peripheral = "Peripheral", t.GDV = "GDV", t.PDV = "PDV", t.Catering = "Catering", t.City = "City", t.District = "District", t.PlaceCentral = "PlaceCentral", t.Town = "Town", t))(se || {}), ce = /* @__PURE__ */ ((t) => (t.North = "North", t.NorthEast = "NorthEast", t.East = "East", t.SouthEast = "SouthEast", t.South = "South", t.SouthWest = "SouthWest", t.West = "West", t.NorthWest = "NorthWest", t))(ce || {}), ve = /* @__PURE__ */ ((t) => (t.Property = "Property", t.Rent = "Rent", t.Lease = "Lease", t))(ve || {}), me = /* @__PURE__ */ ((t) => (t.HigherBudget = "HigherBudget", t.PublicAuction = "PublicAuction", t.InConsultation = "InConsultation", t.ToBeNegotiated = "ToBeNegotiated", t.OnRequest = "OnRequest", t.AnyPlausibleBid = "AnyPlausibleBid", t.FixedPrice = "FixedPrice", t.ByTender = "ByTender", t.AskingPrice = "AskingPrice", t))(me || {}), fe = /* @__PURE__ */ ((t) => (t.Employee = "Employee", t.Contact = "Contact", t))(fe || {}), Se = /* @__PURE__ */ ((t) => (t.PricePerDay = "PricePerDay", t.PricePerWeek = "PricePerWeek", t.PricePerMonth = "PricePerMonth", t.PricePerQuarter = "PricePerQuarter", t.PricePerHalfYear = "PricePerHalfYear", t.PricePerYear = "PricePerYear", t.PricePerContract = "PricePerContract", t))(Se || {}), pe = /* @__PURE__ */ ((t) => (t.MechanicalVentilation = "MechanicalVentilation", t.AlarmSystem = "AlarmSystem", t.Shutters = "Shutters", t.TvCable = "TvCable", t.OutdoorBlinds = "OutdoorBlinds", t.Pool = "Pool", t.Elevator = "Elevator", t.AirConditioning = "AirConditioning", t.Windmill = "Windmill", t.SolarCollectors = "SolarCollectors", t.SatelliteDish = "SatelliteDish", t.Jacuzzi = "Jacuzzi", t.SteamCabin = "SteamCabin", t.SmokeChannel = "SmokeChannel", t.SlidingDoors = "SlidingDoors", t.FrenchBalcony = "FrenchBalcony", t.RoofWindow = "RoofWindow", t.Sauna = "Sauna", t.FiberOpticCable = "FiberOpticCable", t.Internet = "Internet", t.Phone = "Phone", t.Conditioning = "Conditioning", t.SolarPanels = "SolarPanels", t.Cctv = "Cctv", t.HomeAutomation = "HomeAutomation", t.BalanceVentilation = "BalanceVentilation", t.NaturalVentilation = "NaturalVentilation", t))(pe || {}), we = /* @__PURE__ */ ((t) => (t.Leisteen = "Leisteen", t.Cane = "Cane", t.Asbestos = "Asbestos", t.Plastic = "Plastic", t.Tiles = "Tiles", t.BituminousRoofing = "BituminousRoofing", t.Metal = "Metal", t.Other = "Other", t.Ceramic = "Ceramic", t.Slate = "Slate", t.Tinplate = "Tinplate", t.RolledMaterial = "RolledMaterial", t.Stone = "Stone", t.Lath = "Lath", t.PVC = "PVC", t.Galvanized = "Galvanized", t.Concrete = "Concrete", t.Membrane = "Membrane", t.Shingles = "Shingles", t.Wood = "Wood", t.Eternit = "Eternit", t))(we || {}), Pe = /* @__PURE__ */ ((t) => (t.GableRoof = "GableRoof", t.FlatRoof = "FlatRoof", t.PentRoof = "PentRoof", t.MansardRoof = "MansardRoof", t.KapmetPlat = "KapmetPlat", t.SideGabledRoof = "SideGabledRoof", t.CompositeRoof = "CompositeRoof", t.HipRoof = "HipRoof", t.PavilionRoof = "PavilionRoof", t.RoofWithOwlBoards = "RoofWithOwlBoards", t.HelmRoof = "HelmRoof", t.SawtoothRoof = "SawtoothRoof", t.CanopyRoof = "CanopyRoof", t.VaultedRoof = "VaultedRoof", t.Curved = "Curved", t.ShellRoof = "ShellRoof", t.Butterbly = "Butterbly", t.Combination = "Combination", t.Dormer = "Dormer", t.DutchGable = "DutchGable", t.HippedAndValley = "HippedAndValley", t.Jerkinhead = "Jerkinhead", t.MShaped = "MShaped", t.Other = "Other", t.SkillionAndLeanTo = "SkillionAndLeanTo", t))(Pe || {}), Ne = /* @__PURE__ */ ((t) => (t.CostsBuyer = "CostsBuyer", t.FreeOnName = "FreeOnName", t.CostsSplit = "CostsSplit", t))(Ne || {}), Oe = /* @__PURE__ */ ((t) => (t.AttachedStone = "AttachedStone", t.AttachedWood = "AttachedWood", t.DetachedStone = "DetachedStone", t.DetachedWood = "DetachedWood", t.Indoor = "Indoor", t.Box = "Box", t.FreestandingPlastic = "FreestandingPlastic", t))(Oe || {}), Re = /* @__PURE__ */ ((t) => (t.PublicParking = "PublicParking", t.PaidParking = "PaidParking", t.CarPark = "CarPark", t.PermitParking = "PermitParking", t.OnOwnTerrain = "OnOwnTerrain", t.OnClosedGround = "OnClosedGround", t))(Re || {}), Ie = /* @__PURE__ */ ((t) => (t.Meter = "Meter", t.Inch = "Inch", t))(Ie || {}), be = /* @__PURE__ */ ((t) => (t.CubicMeter = "CubicMeter", t))(be || {}), Ae = /* @__PURE__ */ ((t) => (t.Yes = "Yes", t.No = "No", t.Unknown = "Unknown", t))(Ae || {});
class Ee extends Error {
  constructor(n, a, e, r, i) {
    super();
    h(this, "message");
    h(this, "status");
    h(this, "response");
    h(this, "headers");
    h(this, "result");
    h(this, "isSwaggerException", !0);
    this.message = n, this.status = a, this.response = e, this.headers = r, this.result = i;
  }
  static isSwaggerException(n) {
    return n.isSwaggerException === !0;
  }
}
function u(t, l, n, a, e) {
  throw new Ee(t, l, n, a, e);
}
export {
  m as Acceptance,
  f as Amenity,
  S as ApartmentCharacteristic,
  p as AssignmentRelationStatus,
  w as AssignmentRelationType,
  P as BathroomFacility,
  N as BlueprintType,
  O as BrokenBusinessRuleCode,
  R as ChecklistItemResultType,
  I as ChecklistItemStatus,
  b as ChecklistItemStatusType,
  A as ChecklistItemSubmitType,
  Ce as Client,
  E as ConstructionPeriod,
  U as ContractListOfGoodAnswer,
  C as Culture,
  g as DocumentOrientation,
  j as DocumentStatus,
  J as DocumentTargetType,
  D as DocumentType,
  G as ElementEnumerationType,
  F as EnergyClass,
  H as EnergySource,
  W as EntityActionType,
  q as EntityPresenceAction,
  z as EntityType,
  x as ErrorCode,
  V as FormAnswerEditor,
  $ as FormElementCompareActionType,
  k as FormElementConditionType,
  Q as FormElementParentConditionAction,
  B as FormElementPartAvailability,
  Y as FormElementQuestionType,
  K as FormElementTranslationVisibility,
  X as FormElementType,
  Z as FormState,
  M as FormType,
  L as GarageType,
  y as GardenQuality,
  _ as GardenType,
  T as HeatingMethod,
  ee as HeatingWaterMethod,
  te as HouseCharacteristic,
  re as HouseSort,
  ne as HouseType,
  le as InapplicableBoolAnswer,
  ae as InsulationType,
  ue as KitchenFacility,
  ie as KitchenType,
  oe as KnownBoolAnswer,
  he as ListOfItemRadioListAnswer,
  de as ListingType,
  se as LocationPlace,
  ce as Orientation,
  ve as OwnerShip,
  me as PriceCode,
  fe as RelationType,
  Se as RentCondition,
  pe as ResidentialFacility,
  we as RoofMaterial,
  Pe as RoofType,
  Ne as SaleCondition,
  Oe as StorageRoomType,
  Ee as SwaggerException,
  Re as TypeOfParkingFacility,
  Ie as UnitOfMeasurement,
  be as UnitOfVolume,
  Ae as UnknownBoolAnswer
};
